<template>
    <div class="card card-payment-info" style=" background-color: transparent">
        <div class="card-body" style="min-height: 900px;">

            <div class="row">
                <div class="col-sm-6" v-show="visible" v-for="paymentLog in paymentLogs">
                    <div style=" padding: 30px; background-color: rgba(128,128,128,0.08);">
                        <p>
                            <span style="margin-right: 20px; font-size: 17px;"><b>id: </b> {{paymentLog.id}}</span>
                            <span style="margin-right: 20px; font-size: 17px;"><b>payment id: </b> {{paymentLog.payment_id}}</span>
                        </p>
                        <hr>
                        <h4>response: </h4>
                        <vue-json-pretty
                            :path="'res'"
                            :deep="4"
                            :data="paymentLog.response"
                        />

                        <hr>
                        <h4>request: </h4>
                        <vue-json-pretty
                            :path="'res'"
                            :deep="4"
                            :data="paymentLog.request"
                        />
                    </div>
                </div>
                <div v-if="noResponse" class="text-center">
                    <h2>{{ message }}</h2>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
    import VueJsonPretty from 'vue-json-pretty'
    export default {
        name: "TransactionPaymentLogs",
        components: {
            VueJsonPretty
        },
        data() {
            return {
                paymentId: this.paymentIdProp,
                visible: false,
                paymentLogs: [],
                noResponse: false,
                message: '',
            }
        },
        props: ['paymentIdProp'],
        methods: {
            show: function () {
                axios.get('/admin/payment-logs/'+this.paymentId).then(response => {
                    const paymentLogs = response.data;

                    if (paymentLogs.length>0) {
                        this.paymentLogs = paymentLogs;
                        this.visible = true;
                    } else {
                        this.message = 'Нет ответов';
                        this.noResponse = true;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            hide: function () {
                this.visible = false;
            },
        },
    }
</script>
